var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "Button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.handleSubmit("formValidate")
                }
              }
            },
            [_vm._v("保存")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Form",
        {
          ref: "formValidate",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.ruleValidate,
            "label-width": 80
          }
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "姓名", prop: "member.name" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formValidate.member.name,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "name", $$v)
                          },
                          expression: "formValidate.member.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "身份证" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入" },
                        on: {
                          "on-blur": function($event) {
                            return _vm.idCardBlur(
                              _vm.formValidate.member.id_card
                            )
                          }
                        },
                        model: {
                          value: _vm.formValidate.member.id_card,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "id_card", $$v)
                          },
                          expression: "formValidate.member.id_card"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "出生日期" } },
                    [
                      _c("DatePicker", {
                        staticStyle: { display: "block" },
                        attrs: { type: "date", placeholder: "请选择" },
                        model: {
                          value: _vm.formValidate.member.birthday,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "birthday", $$v)
                          },
                          expression: "formValidate.member.birthday"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "手机", prop: "member.phone" } },
                    [
                      _c("Input", {
                        attrs: {
                          placeholder: "请输入",
                          disabled: _vm.disabled
                        },
                        model: {
                          value: _vm.formValidate.member.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "phone", $$v)
                          },
                          expression: "formValidate.member.phone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "性别" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          model: {
                            value: _vm.formValidate.member.sex,
                            callback: function($$v) {
                              _vm.$set(_vm.formValidate.member, "sex", $$v)
                            },
                            expression: "formValidate.member.sex"
                          }
                        },
                        [
                          _c("Radio", { attrs: { label: "1" } }, [
                            _vm._v("男")
                          ]),
                          _vm._v(" "),
                          _c("Radio", { attrs: { label: "2" } }, [_vm._v("女")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "咨询日期", prop: "mail" } },
                    [
                      _c("DatePicker", {
                        staticStyle: { display: "block" },
                        attrs: { type: "date", placeholder: "请选择" },
                        model: {
                          value: _vm.formValidate.member.consult_time,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formValidate.member,
                              "consult_time",
                              $$v
                            )
                          },
                          expression: "formValidate.member.consult_time"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "7" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "所在区域" } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { "on-change": _vm.changeProvince },
                              model: {
                                value: _vm.formValidate.member.province_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formValidate.member,
                                    "province_id",
                                    $$v
                                  )
                                },
                                expression: "formValidate.member.province_id"
                              }
                            },
                            _vm._l(_vm.province, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { "label-width": 0 } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: { "on-change": _vm.changeCity },
                              model: {
                                value: _vm.formValidate.member.city_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formValidate.member,
                                    "city_id",
                                    $$v
                                  )
                                },
                                expression: "formValidate.member.city_id"
                              }
                            },
                            _vm._l(_vm.city, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { "label-width": 0 } },
                        [
                          _c(
                            "Select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: _vm.formValidate.member.area_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.formValidate.member,
                                    "area_id",
                                    $$v
                                  )
                                },
                                expression: "formValidate.member.area_id"
                              }
                            },
                            _vm._l(_vm.area, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "9" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { "label-width": 0 } },
                        [
                          _c("Input", {
                            attrs: { placeholder: "请输入详细地址" },
                            model: {
                              value: _vm.formValidate.member.address,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formValidate.member,
                                  "address",
                                  $$v
                                )
                              },
                              expression: "formValidate.member.address"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "备注", prop: "member.remark" } },
                    [
                      _c("Input", {
                        attrs: {
                          type: "textarea",
                          maxlength: 200,
                          autosize: { minRows: 2, maxRows: 5 },
                          placeholder: "请输入"
                        },
                        model: {
                          value: _vm.formValidate.member.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "remark", $$v)
                          },
                          expression: "formValidate.member.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "民族" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formValidate.member.nation,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "nation", $$v)
                          },
                          expression: "formValidate.member.nation"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "籍贯" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formValidate.member.birth_place,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.formValidate.member,
                              "birth_place",
                              $$v
                            )
                          },
                          expression: "formValidate.member.birth_place"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "学历" } },
                    [
                      _c("Input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formValidate.member.education,
                          callback: function($$v) {
                            _vm.$set(_vm.formValidate.member, "education", $$v)
                          },
                          expression: "formValidate.member.education"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "身高" } },
                    [
                      _c(
                        "Input",
                        {
                          attrs: { type: "number", placeholder: "请输入" },
                          model: {
                            value: _vm.formValidate.member.height,
                            callback: function($$v) {
                              _vm.$set(_vm.formValidate.member, "height", $$v)
                            },
                            expression: "formValidate.member.height"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("CM")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "体重" } },
                    [
                      _c(
                        "Input",
                        {
                          attrs: { type: "number", placeholder: "请输入" },
                          model: {
                            value: _vm.formValidate.member.weight,
                            callback: function($$v) {
                              _vm.$set(_vm.formValidate.member, "weight", $$v)
                            },
                            expression: "formValidate.member.weight"
                          }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "append" }, slot: "append" },
                            [_vm._v("KG")]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "职业" } },
                    [
                      _c(
                        "Select",
                        {
                          staticStyle: {},
                          attrs: { placeholder: "请选择职业" },
                          model: {
                            value: _vm.formValidate.member.job,
                            callback: function($$v) {
                              _vm.$set(_vm.formValidate.member, "job", $$v)
                            },
                            expression: "formValidate.member.job"
                          }
                        },
                        _vm._l(_vm.baseData.industry, function(item) {
                          return _c(
                            "Option",
                            { key: item.id, attrs: { value: item.id } },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "家属信息" } },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addFamily }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.formValidate.maternal_family, function(item, index) {
            return _c(
              "Row",
              { key: item.id },
              [
                _c(
                  "Col",
                  { attrs: { span: "5", offset: "3" } },
                  [
                    _c(
                      "FormItem",
                      { attrs: { "label-width": 0 } },
                      [
                        _c("Input", {
                          attrs: { placeholder: "请输入" },
                          model: {
                            value: item.name,
                            callback: function($$v) {
                              _vm.$set(item, "name", $$v)
                            },
                            expression: "item.name"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Col",
                  { attrs: { span: "5" } },
                  [
                    _c(
                      "FormItem",
                      { attrs: { "label-width": 0 } },
                      [
                        _c(
                          "Select",
                          {
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: item.relation,
                              callback: function($$v) {
                                _vm.$set(item, "relation", $$v)
                              },
                              expression: "item.relation"
                            }
                          },
                          [
                            _c("Option", { attrs: { value: "夫妻" } }, [
                              _vm._v("夫妻")
                            ]),
                            _vm._v(" "),
                            _c("Option", { attrs: { value: "女方家属" } }, [
                              _vm._v("女方家属")
                            ]),
                            _vm._v(" "),
                            _c("Option", { attrs: { value: "男方家属" } }, [
                              _vm._v("男方家属")
                            ]),
                            _vm._v(" "),
                            _c("Option", { attrs: { value: "其他" } }, [
                              _vm._v("其他")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Col",
                  { attrs: { span: "5" } },
                  [
                    _c(
                      "FormItem",
                      { attrs: { "label-width": 0 } },
                      [
                        _c("Input", {
                          attrs: {
                            type: "tel",
                            maxlength: _vm.maxlength,
                            placeholder: "请输入"
                          },
                          on: {
                            "on-blur": function($event) {
                              return _vm.familyPhoneChange(item.phone)
                            }
                          },
                          model: {
                            value: item.phone,
                            callback: function($$v) {
                              _vm.$set(item, "phone", $$v)
                            },
                            expression: "item.phone"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "Col",
                  { attrs: { span: "6" } },
                  [
                    _c(
                      "FormItem",
                      { attrs: { "label-width": 0 } },
                      [
                        _c(
                          "Button",
                          {
                            attrs: { type: "error" },
                            on: {
                              click: function($event) {
                                return _vm.delFamily(index)
                              }
                            }
                          },
                          [_vm._v("删除")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("客户基本信息 "),
      _c(
        "span",
        {
          staticStyle: {
            "font-size": "12px",
            color: "red",
            "font-weight": "400"
          }
        },
        [_vm._v("修改客户信息时记得保存哦")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8f0c14c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8f0c14c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonTmp/CRM/CRM_customerInfo.vue
// module id = null
// module chunks = 